// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PTd2A","colMin":"styles_colMin__28LsN"};